import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CategoriesMenuRootNodeIdService } from '@main/categories-menu/data-access';
import { DeviceService } from '@shared/services';

@Component({
  selector: 'sd-categories-menu',
  templateUrl: './categories-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CategoriesMenuComponent implements OnInit {
  rootNodeId$ = this.categoriesMenuRootNodeIdService.getRootNodeId();

  constructor(
    public deviceService: DeviceService,
    private categoriesMenuRootNodeIdService: CategoriesMenuRootNodeIdService,
  ) {}

  ngOnInit(): void {
    this.categoriesMenuRootNodeIdService.loadRootNodeId();
  }
}
